import React from "react";
import styles from "./Connected.module.css";
import * as FaIcons from "react-icons/fa";
import { IconContext } from "react-icons";
import { Link } from "react-router-dom";
import ConnectedImages from "./ConnectedImages";

function Connected() {
  return (
    <div className={styles.Wrapper}>
      <div className={styles.Title}>
        Don’t just take our word for it! Read what our customers have to say
        about our gifts and hampers.
      </div>
      <div className={styles.Review}>
        <div className={styles.ReviewHeader}>Client Review</div>
        <div>
          “Hannah was so easy to work with and created a bespoke hamper for my
          daughter and her new husband, personalised and gift wrapped
          beautifully. Quick efficient ordering and delivery. Highly
          recommended.”
        </div>
      </div>
      <div className={styles.More}>
      <Link to="/Customer-Services/Reviews" className={styles.Link}>
       <div className={styles.clickhere}>Click here to read more reviews.</div>
        <div className={styles.Stars}>
          <FaIcons.FaStar style={{ color: `#eed9be` }} />
          <FaIcons.FaStar style={{ color: `#eed9be` }} />
          <FaIcons.FaStar style={{ color: `#eed9be` }} />
          <FaIcons.FaStar style={{ color: `#eed9be` }} />
          <FaIcons.FaStar style={{ color: `#eed9be` }} />
        </div>
      </Link>
      </div>
      <ConnectedImages />
      <div className={styles.Footer}>
        <div>Stay connected!</div>
        <div>Tag us in your photos on socials.</div>
        <div className={styles.matchhampers}>@matchhampers</div>
        <div className={styles.Icons}>
          <IconContext.Provider value={{ className: `${styles.Icon}` }}>
            <Link to="https://www.facebook.com/MatchHampers" target="_blank">
              <FaIcons.FaFacebook />
            </Link>
            <Link to="https://www.instagram.com/matchhampers/" target="_blank">
              <FaIcons.FaInstagram />
            </Link>            
          </IconContext.Provider>
        </div>
      </div>
    </div>
  );
}

export default Connected;
